/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto. Keeping custom
* Javascript in this file makes future theme updates easier to manage.
*/

(function() {
  document.addEventListener("DOMContentLoaded", function () {
    // Preserve the existing mobile Shop-menu behavior.
    var shopMenuItem = document.querySelector('[data-handle="shop"]');

    if (shopMenuItem) {
      var dropdownContent = shopMenuItem.querySelector('[data-collapsible-container]');
      var dropdownTrigger = shopMenuItem.querySelector('[data-collapsible-trigger]');

      if (dropdownContent && dropdownTrigger) {
        dropdownContent.classList.add('is-expanded');
        dropdownContent.style.maxHeight = dropdownContent.scrollHeight + "px";
        dropdownContent.setAttribute("aria-hidden", "false");
        dropdownTrigger.classList.add('is-expanded');
        dropdownTrigger.setAttribute("aria-expanded", "true");
      }
    }

    function polishEmptyCart(root) {
      root = root || document;

      root.querySelectorAll('[data-empty-message]').forEach(function(container) {
        var emptyText = container.querySelector('.section__header > p');
        if (!emptyText) {
          emptyText = Array.from(container.children).find(function(el) {
            return el.tagName === 'P' && /cart is currently empty/i.test(el.textContent || '');
          });
        }

        if (emptyText && /cart is currently empty/i.test(emptyText.textContent || '')) {
          emptyText.textContent = 'No pieces are currently selected.';
        }

        var emptyHeading = container.querySelector('.section__heading');
        if (emptyHeading && /^cart$/i.test((emptyHeading.textContent || '').trim())) {
          emptyHeading.textContent = 'YOUR SELECTION';
        }
      });

      // On the dedicated cart page, show only the curated archive state when no items exist.
      var cartPage = root.querySelector('[data-cart-page]') || (root.matches && root.matches('[data-cart-page]') ? root : null);
      if (cartPage) {
        var visibleEmptyState = cartPage.querySelector('[data-empty-message]:not(.hidden)');
        var cartInner = cartPage.querySelector('.cart__inner');
        if (cartInner) {
          if (visibleEmptyState) {
            cartInner.style.setProperty('display', 'none', 'important');
            cartInner.setAttribute('aria-hidden', 'true');
          } else {
            cartInner.style.removeProperty('display');
            cartInner.removeAttribute('aria-hidden');
          }
        }
      }

      // Archive cards already communicate the empty-cart state.
      root.querySelectorAll('[data-cart-message]').forEach(function(message) {
        if (!((message.textContent || '').trim())) {
          message.remove();
        }
      });
    }

    function displayedPriceValue(element) {
      if (!element) return NaN;
      var text = (element.textContent || '').replace(/[^0-9.,-]/g, '').trim();
      if (!text) return NaN;

      if (text.indexOf(',') > -1 && text.indexOf('.') === -1) {
        text = text.replace(',', '.');
      } else {
        text = text.replace(/,/g, '');
      }

      return parseFloat(text);
    }

    function polishProductPrices(root) {
      root = root || document;

      root.querySelectorAll('[data-price-wrapper]').forEach(function(wrapper) {
        var priceElement = wrapper.querySelector('[data-product-price]');
        var compareElement = wrapper.querySelector('[data-compare-price]');
        var saveElement = wrapper.querySelector('[data-price-off]');

        if (!priceElement || !compareElement) return;

        var price = displayedPriceValue(priceElement);
        var compareAt = displayedPriceValue(compareElement);
        var legitimateSale = Number.isFinite(price) && Number.isFinite(compareAt) && compareAt > 0 && compareAt > price;

        compareElement.classList.toggle('hidden', !legitimateSale);
        compareElement.hidden = !legitimateSale;
        compareElement.setAttribute('aria-hidden', legitimateSale ? 'false' : 'true');

        if (saveElement) {
          saveElement.classList.toggle('hidden', !legitimateSale);
          saveElement.hidden = !legitimateSale;
          saveElement.setAttribute('aria-hidden', legitimateSale ? 'false' : 'true');
        }
      });
    }

    polishEmptyCart(document);
    polishProductPrices(document);

    // Cart drawer content is rendered dynamically, so re-apply only when its DOM changes.
    var cartDrawer = document.querySelector('[data-cart-drawer]');
    if (cartDrawer) {
      new MutationObserver(function() {
        polishEmptyCart(cartDrawer);
      }).observe(cartDrawer, { childList: true, subtree: true });
    }

    // Variant selection can rewrite price markup. Re-check after option changes.
    document.addEventListener('change', function(event) {
      if (event.target && event.target.closest('[data-product-form], [data-product-select], [data-single-option-selector], [data-option-selector]')) {
        window.setTimeout(function() {
          polishProductPrices(document);
        }, 0);
      }
    });

    // Also catch theme-driven price text updates that do not emit a native change event.
    if (document.body) {
      new MutationObserver(function(mutations) {
        var priceChanged = mutations.some(function(mutation) {
          var node = mutation.target && mutation.target.nodeType === 1 ? mutation.target : mutation.target && mutation.target.parentElement;
          return node && (node.matches('[data-price-wrapper], [data-price-wrapper] *') || node.closest('[data-price-wrapper]'));
        });

        if (priceChanged) {
          polishProductPrices(document);
        }
      }).observe(document.body, { childList: true, characterData: true, subtree: true });
    }
  });
})();
